import { Storage, Util, Request } from "@xt/xtbase";
import { isFiatMarketCode } from "./fiatMarket";

/**
 * 【法币展示/决策 统一逻辑】IP → 法币代码 / CFD 默认币对。
 * 三国 IP 返回对应法币 CFD；否则兜底 U 本位。与 fiatMarket、getFiatCurrencyMap 等保持一致，修改请同步。
 */
const { getOrigin } = Util;
const { XtAxios4 } = Request;
const RECOMMENDED_FIAT_PLATE_ID = 258;

// 默认法币本位交易对（BRL），供法币区域使用
export const DEFAULT_FIAT_SYMBOL = "btc_brl_cfd";
// 兜底为 U 本位（已去掉现货，跳转交易统一用 CFD）
export const DEFAULT_U_SYMBOL = "btc_usdt_cfd";

// 缓存 key
const CACHE_KEY = "cfd_default_symbol_by_ip";
const CACHE_EXPIRE_TIME = 24 * 60 * 60 * 1000; // 24小时

/**
 * 根据推荐列表获取默认的 CFD 交易对
 * 只信 recommendedCurrencyList 中第一个 plates 含 258 的法币；否则兜底 U 本位。
 * @returns {Promise<string>} 返回交易对符号，如 "btc_usdt_cfd" 或 "btc_aed_cfd"
 */
export async function getCfdSymbolByIP() {
  try {
    const recommendedPayload = Storage.get("recommendedCurrencyList") || {};
    const recommendedCurrencies = recommendedPayload?.currencies || [];
    const recommendedFiat = recommendedCurrencies.find((item) => {
      const code = String(item?.currency || item?.currencyCode || "").toUpperCase();
      const plates = Array.isArray(item?.plates) ? item.plates : [];
      return code && plates.some((plateId) => Number(plateId) === RECOMMENDED_FIAT_PLATE_ID);
    });
    const recommendedFiatCode = String(
      recommendedFiat?.currency || recommendedFiat?.currencyCode || ""
    ).toUpperCase();
    if (recommendedFiatCode && isFiatMarketCode(recommendedFiatCode)) {
      return "btc_" + recommendedFiatCode.toLowerCase() + "_cfd";
    }
    return DEFAULT_U_SYMBOL;
  } catch (error) {
    console.warn("Failed to get CFD symbol by IP:", error);
    return DEFAULT_U_SYMBOL;
  }
}

/**
 * 同步获取缓存的 CFD 交易对（如果缓存存在）
 * @returns {string|null} 返回缓存的交易对，如果没有缓存则返回 null
 */
export function getCachedCfdSymbol() {
  const cached = Storage.get(CACHE_KEY);
  if (cached && cached.symbol && cached.timestamp) {
    const now = Date.now();
    if (now - cached.timestamp < CACHE_EXPIRE_TIME) {
      return cached.symbol;
    }
  }
  return null;
}
